import classNames from "classnames";
import { LabelMap } from "data/Sample";
import { createContext, FunctionComponent, HTMLProps, useCallback, useState } from "react";

import styles from './samplebrowser.module.css';
import { LabelMapView } from "./SampleView";
import { IProjectConnection } from "data/types";
import { InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";



interface SampleBrowserProps{
    samples: LabelMap
    connection: IProjectConnection
}

export const SampleBrowserContext = createContext<{connection: IProjectConnection, searchString: string} | null>(null)

export const SampleBrowser: FunctionComponent<HTMLProps<HTMLDivElement> & SampleBrowserProps> = ({samples, className, connection, style})=>{

    const [searchString, setSearchString] = useState<string>("");

    const setSearch = useCallback((e)=>{setSearchString(e.target.value.toLowerCase())}, [])

    return (
        <div className={classNames(styles['SampleBrowser'], className)} style={style}>
            <h2>Sample Browser</h2>
            <TextField type="search" placeholder="Search" size="small" value={searchString} onChange={setSearch} sx={{width: '100%'}} InputProps={{
                startAdornment: <InputAdornment position="start"><Search/></InputAdornment>
            }}/>
            
            <SampleBrowserContext.Provider value={{connection, searchString}}>
            <div className="sample-list">
                    <LabelMapView sample={samples}/>
            </div>
            </SampleBrowserContext.Provider>
        </div>
    )
}